import React from 'react';
import { useField } from 'formik';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import InfoIcon from '../../../assets/icons/ic-info.svg';
import { useTooltipWithScrollClose } from '../../../hooks/useTooltipWithScrollClose';

interface IProps {
  name: string;
  labelText: string;
  toolTipText?: string;
  disabled?: boolean;
  newData?: any;
  oneField?: any;
  backgroundColour?: string | null;
}

const Checkbox = ({ name, labelText, toolTipText = '', disabled = false, newData, oneField, backgroundColour }: IProps) => {
  const [field, meta] = useField(name);
  const [showTooltip, setShowTooltip] = useTooltipWithScrollClose();

  const changeFieldsValue = checkedValue => {
    const findField = newData?.Pages.map(tab =>
      tab?.Fields?.forEach(f => {
        if (f?.Template?.ID === oneField?.Template?.ID) {
          f.Value = !checkedValue;
        }
      }),
    );
  };

  return (
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        style={{ backgroundColor: backgroundColour || undefined }}
        id={field.name}
        {...field}
        checked={field.value}
        disabled={disabled}
        onClick = {e => {
          if (!disabled) {
            changeFieldsValue(field.value)
          }
        }}
      />
      <label className="form-check-label" htmlFor={field.name}>
        {labelText}
      </label>
      {toolTipText && (
        <OverlayTrigger
          trigger="click"
          rootClose
          placement="bottom"
          show={showTooltip}
          onToggle={setShowTooltip}
          overlay={
            <Tooltip id={`tooltip-${field.name}`}>{toolTipText}</Tooltip>
          }
        >
          <img
            src={InfoIcon}
            alt="info img"
            className="tooltip-trigger"
            data-toggle="tooltip"
            style={{ width: 16, height: 16, marginLeft: 6, verticalAlign: 'middle', cursor: 'pointer' }}
          />
        </OverlayTrigger>
      )}
        {meta.error && <p className="error-wrapper">{meta.error}</p>}
    </div>
  );
};
export { Checkbox };
